import AppStoreContext from 'contexts/AppStoreContext';
import ECSEditorContext from 'contexts/ECSEditorContext';
import ECSWorldContext from 'contexts/ECSWorldContext';
import Markup from 'editor/components/Markup';
import RFIPost from 'editor/components/RFIPost';
import { EditorTools } from 'editor/components/Tool';
import React, { FC, useContext, useEffect } from 'react';
import { PostRFI } from 'records/interactions/PostRFI';
import PostRFIInteractionContent from './PostRFIInteractionContent';

type ManagePostRFIInteractionProps = {
  interaction: PostRFI;
};

const ManagePostRFIInteraction: FC<ManagePostRFIInteractionProps> = (props) => {
  const { interaction } = props;
  const world = useContext(ECSWorldContext);
  const editor = useContext(ECSEditorContext);

  useEffect(() => {
    const { rfi, sheetid, pageid, updatingMarkup, markup } = interaction;

    // If UpdatingMarkup is false, then user is creating a new RFI Post.
    if (!updatingMarkup) {
      world.grabAll(Markup).forEach(({ component }) => {
        component.hidden = true;
        component.selected = false;
      });
    } else if (markup !== null) {
      // Markup is present, probably updating stuff.
      world.grabAll(Markup).forEach(({ component }) => {
        if (component.markup.markupid !== markup?.markupid) {
          component.hidden = true;
        } else {
          component.selected = true;
        }
      });
    }

    const entity = world.createEntity().add(new RFIPost(rfi, sheetid, pageid));

    return () => {
      world.grabAll(Markup).forEach(({ component }) => {
        // Unhide all hidden markups when not in Post RFI "mode"
        component.hidden = false;
        // Temp deselect of all markups after RFI Post stuff.
        component.selected = false;
      });

      editor.tool.tool = EditorTools.Pointer;

      entity.destroy();
    };
  }, []);

  useEffect(() => {
    const { markup } = interaction;

    if (markup === null) {
      editor.tool.tool = EditorTools.PostRFI;
    }
  }, [interaction]);

  return <PostRFIInteractionContent interaction={interaction} />;
};

const ManagePostRFIWrapper: FC = () => {
  const { state: appState } = useContext(AppStoreContext);
  const a = appState.interactions.filter(
    (i): i is PostRFI => i.type === 'PostRFI'
  );

  if (a.size === 1) {
    return <ManagePostRFIInteraction interaction={a.get(0, new PostRFI())} />;
  }

  return null;
};

export default ManagePostRFIWrapper;
